/**
 * Nice-class suggestion — `server/app/routers/nice_classifier.py`.
 *
 * A description spends a real model completion, so this is a mutation (like
 * `useAskCorpus`), never a `useQuery` a stray re-render could refire.
 * `choices` and `rejected` both come back from the server verbatim — this
 * module does not re-check a choice against the candidates client-side,
 * because `check_choices`'s server-side verification is the one that decided
 * which half a choice landed in.
 */

import { useMutation } from '@tanstack/react-query'

import { api } from './client'
import type { SuggestNiceClassRequest, SuggestNiceClassResponse } from './types'

export function useSuggestNiceClasses() {
  return useMutation<SuggestNiceClassResponse, unknown, SuggestNiceClassRequest>({
    mutationFn: (body) => api.post<SuggestNiceClassResponse>('/api/corpus/nice-classes/suggest', body),
  })
}
